import { WhatsNew } from '@typings';

import { MonthContent } from './MonthContent';
import styles from './WhatsNew.module.scss';
import whatsNewContent from './whatsNewContent.json';

export const WhatsNewContent = () => {
  const whatsNewData: WhatsNew.ArticleSet[] = whatsNewContent;

  return (
    <section className={styles.contentContainer}>
      {whatsNewData.map(({ month, year, articles }) => {
        const key = `${year}+${month}`;

        return <MonthContent key={key} month={month} year={year} articles={articles} />;
      })}
    </section>
  );
};
